// extracted by mini-css-extract-plugin
module.exports = {"closeBtn":"index-closeBtn-2Nx5U","closeBtnDlc":"index-closeBtnDlc-15eFl"};